// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchBidIncrementsParams = {
    catalogId: number,
    deployment: string,
};

export const fetchBidIncrements = ({ catalogId, deployment }: FetchBidIncrementsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>spa/small/bid-increments' });
        request.send({ catalogIds: [catalogId] });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
